import { CoachesCarousel } from './CoachesCarousel';

export default CoachesCarousel;
